import React from 'react'
import { styled } from '@mui/material'

type TicketTypeIconProps = {
  value: string | null | undefined
  size?: number
  className?: string
}

const IconFrame = styled('div', {
  shouldForwardProp: prop => prop !== 'size',
})<{ size: number }>(({ size }) => ({
  width: size,
  height: size,
  minWidth: size,
  minHeight: size,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}))

/**
 * チケットタイプ設定画面のアイコン表示コンポーネント。
 *
 * iconUrl は必ずURLのため img で描画する。出所は2系統あり、
 * プリセット種別はバックエンドが返すグローバルCDNのURL、
 * カスタム種別は IconCellEditor がテナントストレージ
 * （POST /api/v1/storages/tenants）へアップロードした永続URL。
 *
 * Tooltipの子になるため ref を転送する。
 */
export const TicketTypeIcon = React.forwardRef<
  HTMLDivElement,
  TicketTypeIconProps
>(({ value, size = 20, className }, ref) => {
  if (!value) {
    return null
  }

  return (
    <IconFrame ref={ref} size={size} className={className}>
      <img src={value} alt="" />
    </IconFrame>
  )
})

TicketTypeIcon.displayName = 'TicketTypeIcon'
